import { string } from 'yup';

const useDynamicTargetListSchema = () => ({
  country: string().required(),
  businessUnit: string().required(),
});

export default useDynamicTargetListSchema;
